import { ChangeDetectionStrategy, Component, Input, output } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { CheckboxModule } from 'primeng/checkbox';
import { SelectModule } from 'primeng/select';
import { UserOrganization } from '../../models/organization';

@Component({
  selector: 'app-organization-select',
  imports: [
    FormsModule,
    SelectModule,
    CheckboxModule
  ],
  templateUrl: './organization-select.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styles: ``,
})
export class OrganizationSelectComponent {
  @Input() items: UserOrganization[] = [];
  @Input() isReadOnly: boolean = false;

  itemsChange = output<UserOrganization[]>();

  selectedItems: UserOrganization[] = [];

  ngOnChanges() {
    if (this.items.length > 0) {
      this.selectedItems = this.items.filter(i => i.associated);
    } else {
      this.selectedItems = [];
    }
  }

  getLabel() : string {
    if (this.selectedItems.length === 0) return '';
        
    let result = this.items.find((o) => o.organizationId === this.selectedItems[0].organizationId)?.name ?? this.selectedItems[0].name;

    if (this.selectedItems.length > 1) {
      result = result + ', ' + (this.items.find((o) => o.organizationId === this.selectedItems[1].organizationId)?.name ?? this.selectedItems[1].name);
    }

    if (this.selectedItems.length > 2) {
      result = result + ', ' + (this.items.find((o) => o.organizationId === this.selectedItems[2].organizationId)?.name ?? this.selectedItems[2].name);
    }

    if (this.selectedItems.length > 3) {
      result = result + `, (+${this.selectedItems.length - 3})`
    }

    return result;
  }

  isItemSelected(organization: UserOrganization): boolean {
    const isSelected: boolean = this.selectedItems.includes(organization);
    let org = this.items.find(o => o.organizationId === organization.organizationId);
    if (org !== undefined) {
      org.associated = isSelected;
    }

    return isSelected;
  }

  // Questa funzione scatta ad ogni click o cambio di selezione nel dropdown
  onSelectionChange() {
    // 1. Aggiorna lo stato booleano "isSelected" su ogni record dell'array originale
    this.items.forEach(item => {
      item.associated = this.selectedItems.some(selected => selected.organizationId === item.organizationId);
      if (!item.associated) {
        item.departments = [];
      }
    });

    // 2. Notifica il componente padre inviando una copia fresca dell'array
    this.itemsChange.emit([...this.items]);
  }
}
